<section class="business-industries">
  <h2>Solutions for <span class="accent">every industry</span></h2>
  <p class="section-subtitle">The same platform, shaped around how your business runs day to day.</p>

  <div class="flow-timeline">
    <div
      class="flow-item"
      #flowItem
      *ngFor="let industry of industries; let i = index"
      [class.flow-item-reverse]="i % 2 === 1"
      [style.transition-delay.ms]="i * 40"
      [style.--node-color]="industry.color"
    >
      <div class="flow-node">
        <img [src]="industry.image" [alt]="industry.title" />
      </div>

      <div class="flow-content">
        <h3>{{ industry.title }}</h3>
        <p>{{ industry.description }}</p>
      </div>
    </div>
  </div>
</section>
